import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';
import ClusterTabs from '../../Components/company/components/ClusterTabs';
import { Waypoint } from 'react-waypoint';
import CompanyInfo from '../../Components/company/components/CompanyInfo';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllCompanyDetailsLoading, selectClusterCompanyNews, selectClusterCompanyNewsFilter, selectClusterCompanyNewsFilterLoading, selectClusterCompanyNewsFilterSelected, selectClusterCompanyProfile, selectClusterCompanyProfileLoading, selectClusterStrategicHighlights, selectClusterStrategicHighlightsLoading, selectClusterSWOTLoading, selectSelectedClusterCompanies } from '../../Selector/ClustersSelector';
import { Col, Row, Spin } from 'antd';
import CompanyDetails from '../../Components/company/components/CompanyDetails';
import { actions as clusterActions } from '../../Slice/ClustersSlice';
import StrategicHighlights from '../../Components/common/components/StrategicHighlights';
import { appBgColor, loadingGifV6, loadingGifV7, maxTablet, maxWidth, primaryFont, primaryHeadingColor, retina, secondaryFont, wMBold, wMedium } from '../../Utils/utilsStyle';
import { SelectedCompany } from '../../Types/ClustersTypes';
import SwotTab from '../../Components/company/components/SwotTab';
import SwotAnalysis from '../../Components/company/components/SwotAnalysis';
import StrategicHighlightsSkeleton from '../../Components/common/skeleton/StrategicHighlightsSkeleton';
import CompanyDetailsTab from '../../Components/company/components/CompanyDetailsTab';
import Financials from '../../Components/company/components/Financials';
import CompanyNewsTab from '../../Components/company/components/CompanyNewsTab';
import ViewTabs from '../../Components/common/tabs/ViewTabs';
import { ViewInterface } from '../../Types/GlobalTypes';
import { selectViewTab } from '../../Selector/UISelector';
import classNames from 'classnames';
import { Article } from '../../Types/ArticleTypes';
import FilterPopOver from '../../Components/common/components/FilterPopOver';
import { Filter } from '../../Types/FilterTypes';
import { allValueInKeyOfArrayExists, anyValueInKeyOfArrayExists, getLocalStorageObject, isAPrivateCompany, IsTablet } from '../../Utils/UtilityFunctions';
import ClusterFilterPopover from '../../Components/company/components/ClusterFilterPopover';
import { actions as UiAction } from '../../Slice/UISlice';
import CompanyCardSkeleton from '../../Components/common/skeleton/CompanyCardSkeleton';

const Wrapper = styled.div`
  .tabs-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 80px;
    z-index: 2;
    background: ${appBgColor};
    padding: 12px 0;
    @media all and (max-width: ${maxTablet}) {
      top: 65px;
    }
    .right-side-sub-header {
      display: flex;
      align-items: center;
      column-gap: 8px;
      position: absolute;
      right: 0%;
      .view-tabs {
        .tabs-wrapper {
          .tabs-item {
            height: 34px;
            svg {
              height: 32px;
            }
          }
        }
      }
      .filter-placeholder {
        .tabs-wrapper {
          .ant-btn {
            min-height: 34px;
          }
        } 
      }

    }
  }
  margin-top: 24px;
  .content-wrapper {
    margin-top: 24px;
    min-height: 400px;
    border-radius: 12px;
    /* background: #fff; */
    /* padding: 24px; */
    .container-company-card {
      background: white;
      padding: 0px 0px 24px;
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.04);
      .company-info-wrapper {
        .bottom-btn-div {
          display: none;
        }
      }
      .company-details-btns-slider {
        display: none;
      }
      .body-part {
        margin-top: 32px;
      }
    }
    .highlights-section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 15px;
      margin-bottom: 15px;
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
    }
    .swot-section {
      background-color: rgb(255, 255, 255);
      border-radius: 16px;
      padding: 24px;
      margin-bottom: 16px;
      .swot-tab-area {
        .sticky-header-swot {
          position: unset;
        }
      }
      
      @media all and (max-width: ${maxWidth}), ${retina} {
        border-radius: 12px;
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }
    .details-section {
      display: flex;
      flex-direction: column;
      row-gap: 16px; 
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
      .details {
        .company-details-heading {
          display: none;
        }
      }
    }
    .financials-section {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
      .fin-div {
        #tabs-details {
          .company-financial-heading {
            display: none;
          }
        }
      }
      &.empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${primaryHeadingColor};
        text-align: center;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 20px;
        min-height: 400px;
      }
    }
    .triggers-section {
      .companyNewsTabWrapper {
        .triggerWrapper {
          background: none;
          border-radius: 0px;
          box-shadow: none;
        }
        .highlight-skeleton {
          display: none;
        }
        .swot-analysis-area {
          display: none;
        }
        .listviewTagsAndStatsWrapper {
          display: none;
        }
        .tagsAndIntentDataWrapper {
          display: none;
        }
        .progress-wrapper {
          display: none;
        }
        #trigger-details {
          .heading-inner-page {
            margin-bottom: 16px;
            padding: 0px
          }
          .infiniteScrollWrapper {
            padding: 0px;
          }
        }
      }
    }
  }
`;
type Props = {
  clusterId: number
  handleHighlightClick?: (prompt: string) => void,
  onGilroyClose?: () => void;
}

const defaultProps = {
  clusterId: 0,
  onGilroyClose: () => { },
}
const ClusterInsightSection = function ClusterInsightSection(props: Props) {
  const { clusterId, handleHighlightClick, onGilroyClose = () => { } } = props
  const dispatch = useDispatch();

  const selectedCompanies = useSelector(selectSelectedClusterCompanies);
  const [tabPending, setTabPending] = useState(false);
  const [initialised, setInitialised] = useState(false);
  const [activeTab, setActiveTab] = useState('Overview');
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const loadedTabsRef = useRef<Record<string, string>>({});
  const tabs = [
    'Overview',
    'Strategic Highlights',
    'S.W.O.T Analysis',
    'Sales Triggers',
    'Financials',
    'Details',
  ];
  const companyProfile = useSelector(selectClusterCompanyProfile);
  const companyProfileLoading = useSelector(selectClusterCompanyProfileLoading);
  const strategicHighligths = useSelector(selectClusterStrategicHighlights);
  const strategicHighlightsLoading = useSelector(selectClusterStrategicHighlightsLoading);
  const allCompanyDetailsLoading = useSelector(selectAllCompanyDetailsLoading)
  const selectedCompaniesId = selectedCompanies.map((company) => company.companyId);
  const swotLoading = useSelector(selectClusterSWOTLoading);
  const isTab = IsTablet();
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const getPath = getLocalStorageObject('ViewTab') as ViewInterface;
  const [disableFilter, setDisableFilter] = useState(true);
  const companyNewsArticles: Article[] | null = useSelector(selectClusterCompanyNews);
  const [filters, setFilters] = useState<Filter[]>([]);
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<Filter[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(true);
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);
  const [isFilterChanged, setIsFilterChanged] = useState<boolean>(false);
  const newsFiltersFromRedux = useSelector(selectClusterCompanyNewsFilter);
  const selectedNewsFilters = useSelector(selectClusterCompanyNewsFilterSelected);
  const [selectedFilterCompanies, setSelectedFilterCompanies] = useState<number[]>(selectedCompaniesId);
  const [previousSelectedCompanyIds, setPreviousSelectedCompanyIds] = useState<number[]>(selectedCompaniesId);
  const companyNewsFiltersLoading = useSelector(selectClusterCompanyNewsFilterLoading);

  // const tabHasLoadingOrData = () => {
  //   if (!selectedCompanies?.length) return true;
  //   switch (activeTab) {
  //     case 'Overview':
  //       return selectedCompanies.every((company) => !!companyProfile[company.companyId] || Boolean(companyProfileLoading[company.companyId]));
  //     case 'Strategic Highlights':
  //       return selectedCompanies.every((company) => (strategicHighligths[company.companyId]?.length > 0) || Boolean(strategicHighlightsLoading[company.companyId]));
  //     case 'S.W.O.T Analysis':
  //       return selectedCompanies.every((company) => Boolean(swotLoading[company.companyId]));
  //     case 'Sales Triggers':
  //       return !companyNewsFiltersLoading || Boolean(companyNewsArticles && companyNewsArticles.length > 0);
  //     case 'Financials':
  //       return selectedCompanies.every((company) => !!companyProfile[company.companyId] || Boolean(companyProfileLoading[company.companyId]));
  //     case 'Details':
  //       return selectedCompanies.every((company) => !!companyProfile[company.companyId] || Boolean(companyProfileLoading[company.companyId]));
  //     default:
  //       return true;
  //   }
  // };

  const hasCompanyFinancialData = (profile: any) => {
    if (!profile || isAPrivateCompany(profile)) return false;
    const financialInfo = profile.companyFinancialInfo;
    if (!financialInfo) return false;
    if (financialInfo.sections?.length) return true;
    if (financialInfo.earningAndReports?.length) return true;
    return false;
  };

  const companiesWithFinancials = selectedCompanies?.filter((company) => {
    const profile = companyProfile[company.companyId];
    return hasCompanyFinancialData(profile);
  }) || [];

  useEffect(() => {
    loadedTabsRef.current = {};
  }, [clusterId])

  // useEffect(() => {
  //   // mark tab as pending when user switches tab or selection changes
  //   setTabPending(true);
  // }, [activeTab, selectedCompanies]);

  // useEffect(() => {
  //   if (!tabPending) return;
  //   if (tabHasLoadingOrData()) {
  //     setTabPending(false);
  //   }
  // }, [tabPending, activeTab, selectedCompanies, companyProfile, companyProfileLoading, strategicHighligths, strategicHighlightsLoading, swotLoading, companyNewsArticles, companyNewsFiltersLoading, allCompanyDetailsLoading]);

  useEffect(() => {
    setActiveTab('Overview');
  }, [selectedCompanies]);

  useEffect(() => {
    if (!companyNewsFiltersLoading) {
      setDisableFilter(false)
    }
  }, [companyNewsFiltersLoading])

  useEffect(() => {
    dispatch(UiAction.isTabView({
      view: getPath.view,
    }));
  }, [getPath.view]);

  useEffect(() => {
    if (isFilterChanged) {
      if (
        anyValueInKeyOfArrayExists(
          filters,
          'isSelected',
          false
        )
      ) {
        setIsFilterActive(true);
      } else {
        setIsFilterActive(false);
      }

      setIsFilterChanged(false);
    }
  }, [isFilterChanged, filters]);

  useEffect(() => {
    if (selectedNewsFilters.length) {
      const filterId = selectedNewsFilters.split(',');
      const filterTemp = newsFiltersFromRedux.map((filter) => {
        if (filterId.includes(filter.filterId)) {
          return { ...filter, isSelected: true };
        }
        return { ...filter, isSelected: false };
      });
      setFilters(filterTemp);
      setPreviousNewsFiltersApplied(filterTemp);
    } else {
      setFilters(newsFiltersFromRedux);
      setPreviousNewsFiltersApplied(newsFiltersFromRedux);
    }

    setSelectAll(allValueInKeyOfArrayExists(newsFiltersFromRedux, 'isSelected', true));
  }, [newsFiltersFromRedux]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Overview':
        return (
          <>
            {
              selectedCompanies?.map((company, index) => {
                const profile = companyProfile[company.companyId];
                const loading = companyProfileLoading[company.companyId];
                if (!profile && !loading) return null;
                return (
                  <Waypoint
                  // onEnter={() => dispatch(companiesActions.pushCurrentSection('Overview'))} onLeave={() => dispatch(companiesActions.removeCurrentSection('Overview'))}
                  >
                    <div className={`container-company-card `} id="certification-company-tabs">
                      {loading && !profile ? (
                        <div className="overview-loading-card" >
                          <CompanyCardSkeleton />
                        </div>
                      ) : (
                        <>
                          <Row>
                            <Col
                              xxl={{ span: 6 }}
                              xl={{ span: 8 }}
                              lg={{ span: 8 }}
                              md={{ span: 8 }}
                              sm={{ span: 24 }}
                              xs={{ span: 24 }}
                            >
                              {companyProfile && (
                                <CompanyInfo
                                  companyProfile={profile}
                                  isCluster
                                  companyIndex={index + 1}
                                  totalCompanies={selectedCompanies.length}
                                />
                              )}
                            </Col>
                            <Col
                              xxl={{ span: 18 }}
                              xl={{ span: 16 }}
                              lg={{ span: 16 }}
                              md={{ span: 16 }}
                              sm={{ span: 24 }}
                              xs={{ span: 24 }}
                              className="second-col-area"
                            >
                              {companyProfile &&
                                <CompanyDetails
                                  companyProfile={profile}
                                  showSAPHierarchy={false}
                                  userCompanyId={company.companyId}
                                  isCluster
                                />
                              }
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                  </Waypoint>
                )
              })

            }

          </>
        );

      case 'Strategic Highlights':
        return (
          <>
            {
              selectedCompanies?.map((company) => {
                const loading = Boolean(strategicHighlightsLoading[company.companyId]);
                const highlights = strategicHighligths[company.companyId];
                return (
                  <div className='highlights-section' key={company.companyId}>
                    <div className='company-name'>{company.companyName}</div>
                    <StrategicHighlights
                      strategicHighlights={highlights}
                      handleClick={handleHighlightClick}
                      onGilroyClose={onGilroyClose}
                      clusterLoading={loading}
                      isCluster={true}
                    />
                  </div>
                );
              })
            }
          </>
        );

      case 'S.W.O.T Analysis':
        return (
          <>
            {
              selectedCompanies?.map((company) => (
                <div className='swot-section'>
                  <SwotAnalysis
                    isSwotTab={true}
                    isCluster={true}
                    clusterCompanyId={company.companyId}
                    clusterCompanyName={company.companyName}
                  />
                </div>
              ))
            }
          </>
        );

      case 'Sales Triggers':
        return (
          <div className='triggers-section'>
            <CompanyNewsTab
              listview={isListView}
              onGilroyClose={onGilroyClose}
              isCluster={true}
            />
          </div>
        );

      case 'Financials': {
        if (!companiesWithFinancials.length) {
          return (
            <div className='financials-section empty-state'>
              No public Financials data found
            </div>
          );
        }

        return (
          <>
            {
              companiesWithFinancials.map((company) => (
                <div key={company.companyId} className='financials-section'>
                  <div className='company-name'>
                    {company.companyName}
                  </div>
                  <div className='fin-div'>
                    <Financials
                      redirect=""
                      isCluster
                      clusterCompanyId={company.companyId}
                    />
                  </div>
                </div>
              ))
            }
          </>
        );
      }

      case 'Details':
        return (
          <>
            {
              selectedCompanies?.map((company) => (
                <div className="details-section">
                  <div className="company-name">{company.companyName}</div>
                  <div className='details'>
                    <CompanyDetailsTab
                      isCluster={true}
                      companyId={company.companyId}
                    />
                  </div>
                </div>
              ))
            }
          </>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (!selectedCompanies?.length) return;

    const companiesKey = selectedCompanies
      .map((company) => company.companyId)
      .sort((a, b) => a - b)
      .join(',');

    const alreadyLoaded = loadedTabsRef.current[activeTab] === companiesKey;

    if (alreadyLoaded) {
      return;
    }

    switch (activeTab) {
      case 'Overview':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterCompanyProfile({
            companyId: company.companyId,
          }));
          dispatch(clusterActions.getClusterStocksChart({
            companyId: company.companyId,
          }))
        })
        break;

      case 'Strategic Highlights':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterStrategicHighlight({
            companyId: company.companyId,
            type: 'company',
            key: 'company_strategic_highlights',
          }));
        })

        break;

      case 'S.W.O.T Analysis':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterSWOTAnalysis({
            companyId: company.companyId
          }));
        })
        break;

      case 'Sales Triggers':
        dispatch(clusterActions.getClusterCompanyNews({
          companyId: selectedCompaniesId.join(','),
          page: 1,
        }))
        break;

      case 'Financials':
        selectedCompanies?.forEach((company) => {
          if (!companyProfile[company.companyId]) {
            dispatch(clusterActions.getClusterCompanyProfile({
              companyId: company.companyId,
            }));
          }
          dispatch(clusterActions.getClusterStocksChart({
            companyId: company.companyId,
          }));
          dispatch(clusterActions.getClusterCompanySecFillings({
            companyId: company.companyId,
          }));
        });
        break;

      default: break;
    }
    loadedTabsRef.current[activeTab] = companiesKey;
  }, [activeTab, selectedCompanies]);

  const onChangeFilters = (flag: boolean, id: string) => {
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === id) {
        return { ...filter, isSelected: flag };
      } return { ...filter };
    });
    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
  };

  const onChangeCompanies = (companyId: number) => {
    setSelectedFilterCompanies((prev) =>
      prev.includes(companyId)
        ? prev.filter((id) => id !== companyId)
        : [...prev, companyId]
    );
  }

  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };

  const applyFilterHandler = () => {
    dispatch(clusterActions.setClusterCompanyNewsPageNumber(1));
    dispatch(clusterActions.setClusterNewsFilterApplied());
    const selectedNewsFilter = filters.filter((item) => item.isSelected).map((item) => item.filterId).join(',');
    dispatch(clusterActions.getClusterCompanyNews({
      companyId: selectedFilterCompanies.join(','),
      ...selectedNewsFilter.length ? {
        newsFilters: selectedNewsFilter
      } : {},
      page: 1,
    }))


    dispatch(clusterActions.setClusterCompanyNewsFiltersSelected(selectedNewsFilter));
    setPreviousNewsFiltersApplied(filters);
    setIsFilterChanged(true);
  };

  const checkForApplyFilter = () => {
    const filtersChanged = filters.some(
      (filter, index) =>
        filter.isSelected !==
        previousNewsFiltersApplied[index]?.isSelected,
    );

    const companiesChanged =
      JSON.stringify([...selectedFilterCompanies].sort()) !==
      JSON.stringify([...previousSelectedCompanyIds].sort());

    return !(filtersChanged || companiesChanged);
  };

  useEffect(() => {
    if (isFilterChanged) {
      if (
        anyValueInKeyOfArrayExists(
          filters,
          'isSelected',
          false
        )
      ) {
        setIsFilterActive(true);
      } else {
        setIsFilterActive(false);
      }

      setIsFilterChanged(false);
    }
  }, [isFilterChanged, filters]);

  useEffect(() => {
    if (selectedNewsFilters.length) {
      const filterId = selectedNewsFilters.split(',');
      const filterTemp = newsFiltersFromRedux.map((filter) => {
        if (filterId.includes(filter.filterId)) {
          return { ...filter, isSelected: true };
        }
        return { ...filter, isSelected: false };
      });
      setFilters(filterTemp);
      setPreviousNewsFiltersApplied(filterTemp);
    } else {
      setFilters(newsFiltersFromRedux);
      setPreviousNewsFiltersApplied(newsFiltersFromRedux);
    }

    setSelectAll(allValueInKeyOfArrayExists(newsFiltersFromRedux, 'isSelected', true));
  }, [newsFiltersFromRedux]);

  return (
    <Wrapper ref={scrollContainerRef}>
      <>
        <div className='tabs-header'>
          <ClusterTabs
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            scrollContainerRef={scrollContainerRef}
          />
          {
            activeTab === 'Sales Triggers' && (
              <div className="right-side-sub-header">
                <div className={classNames('view-tabs', {
                  notdisabledTabs: true,
                })}
                >
                  <ViewTabs
                    disabled={disableFilter}
                    listView={isListView}
                  />
                </div>
                <div className={classNames('filter-placeholder', {
                  notDisabledFilter: (companyNewsArticles?.length
                    // || newsFilterApplied
                  )
                    && filters.length > 0 && !disableFilter,
                })}
                >
                  <ClusterFilterPopover
                    filters={filters}
                    selectedCompanies={selectedCompanies as any}
                    selectedCompaniesId={selectedFilterCompanies as any}
                    loading={false}
                    selectAll={selectAll}
                    onChangeFilters={onChangeFilters}
                    onChangeCompanies={onChangeCompanies}
                    onClickHandler={onClickHandler}
                    applyFilterHandler={applyFilterHandler}
                    disableApplyBtn={checkForApplyFilter()}
                    iconMode={isTab}
                    isActive={isFilterActive && !disableFilter}
                    salesTriggerPopup
                    showContent={!disableFilter}
                  />
                </div>
              </div>
            )
          }

        </div>
        <div className="content-wrapper">
          {/* {(tabPending && !tabHasLoadingOrData()) ? (
            <div className="not-applied-section">
              <Spin />
            </div>
          ) :  */}
          {allCompanyDetailsLoading ? (
            <div className="not-applied-section">
              <img className='gilroy-loader' src={loadingGifV7} alt="loading" />
            </div>
          ) : (
            renderTabContent()
          )}
        </div>
      </>
    </Wrapper>
  );
};

ClusterInsightSection.defaultProps = defaultProps;
export default ClusterInsightSection;